import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { AREA_CONSTANTS } from './services/auth'
import {
  PublishingGroupsManagementPage,
  GroupSettingsPage,
  NewPackPage,
  PackPage,
  GroupPublishPage,
  GroupViewPage,
  HomePage,
  ComponentsLibPage,
  SearchPage,
  ConsumerSearchPage,
  CapabilitiesPage,
  MediaTypesPage,
  MediaTypeSettingsPage,
  MediaTypeGroupsPage,
  MediaTypeGroupSettingsPage,
  CapabilitySettingsPage,
  PublishedGraphicPage,
} from './pages'
import { ProtectedRoute } from './components'

export const Router = () => (
  <Switch>
    <Route exact path="/" component={HomePage} />
    <ProtectedRoute
      exact
      path="/settings/groups/:groupId"
      component={GroupSettingsPage}
      area={AREA_CONSTANTS.SETTINGS_GROUP}
    />
    <Route exact path="/group/:groupId" component={GroupViewPage} />
    <ProtectedRoute
      exact
      path="/settings/groups"
      component={PublishingGroupsManagementPage}
      area={AREA_CONSTANTS.SETTINGS_ALL_GROUPS}
    />
    <ProtectedRoute
      exact
      path="/group/:groupId/publish"
      component={GroupPublishPage}
      area={AREA_CONSTANTS.GROUP_PUBLISHING_AREA}
    />
    <ProtectedRoute
      exact
      path="/group/:groupId/pack/create"
      component={NewPackPage}
      area={AREA_CONSTANTS.CREATE_PACK}
    />
    <ProtectedRoute
      path="/group/:groupId/pack/:packId"
      component={PackPage}
      area={AREA_CONSTANTS.VIEW_PACK}
    />
    <ProtectedRoute
      path="/group/:groupId/search"
      component={SearchPage}
      area={AREA_CONSTANTS.PUBLISHED_SEARCH}
    />
    <Route path="/consumersearch" component={ConsumerSearchPage} />
    <ProtectedRoute
      exact
      path="/settings/media-types/:extension"
      component={MediaTypeSettingsPage}
      area={AREA_CONSTANTS.SETTINGS_MEDIA_TYPE}
    />
    <ProtectedRoute
      exact
      path="/settings/media-types"
      component={MediaTypesPage}
      area={AREA_CONSTANTS.SETTINGS_ALL_MEDIA_TYPES}
    />
    <ProtectedRoute
      exact
      path="/settings/media-type-groups/:id"
      component={MediaTypeGroupSettingsPage}
      area={AREA_CONSTANTS.SETTINGS_MEDIA_TYPE_GROUP}
    />
    <ProtectedRoute
      exact
      path="/settings/media-type-groups"
      component={MediaTypeGroupsPage}
      area={AREA_CONSTANTS.SETTINGS_ALL_MEDIA_TYPE_GROUPS}
    />
    <ProtectedRoute
      exact
      path="/settings/capabilities"
      component={CapabilitiesPage}
      area={AREA_CONSTANTS.SETTINGS_ALL_CAPABILITIES}
    />
    <ProtectedRoute
      exact
      path="/settings/capabilities/:id"
      component={CapabilitySettingsPage}
      area={AREA_CONSTANTS.SETTINGS_CAPABILITY}
    />
    <Route path="/graphic/:graphicId" component={PublishedGraphicPage} />
    <Route exact path="/lib" component={ComponentsLibPage} />
  </Switch>
)
